module.exports = __webpack_public_path__ + "img/icon运动员等级_职工二级@3x.a604e906.png";